import LUpload from './src/main'

/* istanbul ignore next */
LUpload.install = function(Vue) {
  Vue.component(LUpload.name, LUpload)
}

export default LUpload
